/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { ACSStrictHttpResponse } from '../../acs-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LobbyImageModel } from '../../models/lobby-image-model';

export interface LobbyImageIdGet$Params {
  id: string;
}

export function lobbyImageIdGet(http: HttpClient, rootUrl: string, params: LobbyImageIdGet$Params, context?: HttpContext): Observable<ACSStrictHttpResponse<LobbyImageModel>> {
  const rb = new RequestBuilder(rootUrl, lobbyImageIdGet.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as ACSStrictHttpResponse<LobbyImageModel>;
    })
  );
}

lobbyImageIdGet.PATH = '/Lobby/Image/{id}';
